import Vue from "vue";
export const EventBus = new Vue();
window.EventBus = new Vue();